export const REQUEST_TELL_ME_MORE_PAGE_INFORMATION = 'REQUEST_TELL_ME_MORE_PAGE_INFORMATION';
export const TELL_ME_MORE_PAGE_INFORMATION_ERROR = 'TELL_ME_MORE_PAGE_INFORMATION_ERROR';
export const TELL_ME_MORE_PAGE_INFORMATION_SUCCESS = 'TELL_ME_MORE_PAGE_INFORMATION_SUCCESS';
export const SAVE_CHANGES_TO_TELL_ME_MORE_PAGE =
  'SAVE_CHANGES_TO_TELL_ME_MORE_PAGE';
export const SAVE_CHANGES_TO_TELL_ME_MORE_PAGE_SUCCESS = 'SAVE_CHANGES_TO_TELL_ME_MORE_PAGE_SUCCESS';
export const SAVE_CHANGES_TO_TELL_ME_MORE_PAGE_ERROR = 'SAVE_CHANGES_TO_TELL_ME_MORE_PAGE_ERROR';